import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { chatSelector } from "../../../../../store/selector";
import { connect } from "react-redux";
import { chatAction, messageAction } from "../../../../../store/action";
import { getTime } from "../../utils";
import APIManager from "modules/common/apiManager";
import Retry from "./Retry";
import { changeLastMessage } from "../../../../../dialpad/service/chat.service";
import "./DocumentCustom.css";
import styled from "styled-components";
import { formatMessage } from "../utils/generic";
const mAPI = new APIManager();

const CustomerDoc = styled.div`
  // width: 250px;
  .caption {
    // font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    margin-top: 10px;
    padding: 0px 8px 0px 8px;
  }
`;

const AgentDoc = styled.div`
  // width: 250px;
  .caption {
    // font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    margin-top: 10px;
    // color: #fff;
    padding: 0px 8px 0px 8px;
  }
`;

function DocumentCustom({ message, ...props }) {
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(false);
  // const [DocSize, setDocSize] = useState(0);
  const {
    dynamicUpdate,
    selectedDocs: selectedDocsFromRedux,
    retryDocs,
  } = props;

  let docLink =
    (message &&
      message.content &&
      message.content.card &&
      message.content.card.media &&
      message.content.card.media.link) ||
    "";
  let docType =
    (message &&
      message.content &&
      message.content.card &&
      message.content.card.media &&
      message.content.card.media.type) ||
    "";
  useEffect(() => {
    if (error) {
      setLoading(null);
    }
  }, [error]);

  useEffect(() => {
    console.log("message is this", message);
  }, [message]);

  useEffect(() => {
    console.log("retry loding is this", loading);
    if (loading >= 99) {
      setLoading(null);
    }
  }, [loading]);

  const loadingFn = ({ detail }) => {
    console.log({ detail }, "kkghnkfjnhljnjlhbhjb");
    const msgId = message && message.id;
    if (msgId === detail.id) {
      if (detail.success === false) {
        setError(true);
        return;
      }
      setLoading(detail.loading);
    }
  };

  useEffect(() => {
    window.addEventListener("custom-chat-event", loadingFn);
    // if (message && message.content && message.content.link) {
    //   getFileSize(docLink);
    // }
    return () => {
      window.removeEventListener("custom-chat-event", loadingFn);
    };
  }, []);

  const getPublicUrl = (formData, uniqueId, currDoc) => {
    const { messageList, selectedAssignedList } = props;
    const id = message && message.id;
    return new Promise((res, rej) => {
      mAPI.sendPostForm(
        `chat/upload`,
        formData,
        (data) => {
          res(data);
        },
        (errorCode, data) => {
          // const event = createChatEvent({id: uniqueId, success: false})
          // window.dispatchEvent(event)
          setError(true);
          let alreadyExist = false;
          if (message && message.error) {
            alreadyExist = true;
          }
          if (!alreadyExist) {
            dynamicUpdate({
              data: {
                key: `messageList.${selectedAssignedList.identifier}`,
                value: [
                  ...messageList[`${selectedAssignedList.identifier}`].map(
                    (d) => {
                      if (d.id === uniqueId) {
                        return { ...d, error: true };
                      }
                      return d;
                    }
                  ),
                ],
              },
            });
          }
        },
        "private",
        (data) => {
          const progress = Math.round((100 * data.loaded) / data.total);
          dynamicUpdate({
            data: {
              key: `messageList.${selectedAssignedList.identifier}`,
              value: [
                ...messageList[`${selectedAssignedList.identifier}`].map(
                  (d) => {
                    if (d.id === uniqueId) {
                      delete d.error;
                      return { ...d };
                    }
                    return d;
                  }
                ),
              ],
            },
          });
          setLoading(progress);
          setError(false);
        }
      );
    });
  };

  const sendMessage = async (e) => {
    setError(false);
    const {
      configProcessor,
      messageList,
      assignedList,
      selectedAssignedList,
      dynamicUpdate,
    } = props;
    let currDoc = {};
    if (message && message.content && message.content.file) {
      currDoc = message.content.file;
    }
    const mimeType = currDoc.type;
    const commonPayload = {
      from: "agent",
      timeStamp: getTime(),
      type: "document",
      content: {
        link: URL.createObjectURL(currDoc),
        mimeType: mimeType,
        fileName: currDoc.name,
        fileSize: currDoc.size,
      },
      // "id": uniqueId,
      loading: 0,
    };
    // dynamicUpdate({ data: { key: `messageList.${selectedAssignedList.identifier}`, value: [...messageList[selectedAssignedList.identifier] || [], commonPayload] } })
    const formData = new FormData();
    formData.append("file", currDoc);
    const data = await getPublicUrl(formData, message.id, currDoc);
    // got public url, so remove this image from retry image in redux

    const messagePayload = {
      ...commonPayload,
      content: {
        ...data,
        mimeType: mimeType,
      },
    };
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: "message",
      "rmq:pattern": "agent:message",
      message: {
        ...(selectedAssignedList && selectedAssignedList.message),
        ...messagePayload,
      },
    });

    changeLastMessage({
      list: assignedList,
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assignedList",
    });
  };

  // if (loading) {
  //   return (
  //     <div className="msg-doc_loader">
  //       {" "}
  //       <Loader loadingPercentage={loading} />
  //     </div>
  //   );
  // }
  // async function getFileSize(url) {
  //   const pdfLink = url;

  //   fetch(pdfLink)
  //     .then((response) => {
  //       const contentLength = response.headers.get("content-length");
  //       const sizeInBytes = parseInt(contentLength, 10);

  //       if (!isNaN(sizeInBytes)) {
  //         setDocSize(formatBytes(sizeInBytes));
  //       } else {
  //         console.log("Unable to determine PDF size.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching PDF:", error);
  //     });
  // }

  function downloadPDF(url) {
    console.log("urlDocument", url);
    if (!url) return;
    // const a = document.createElement("a");
    // a.href = url;
    // a.style.display = "none";
    // a.target = "_blank";
    // a.download = url || "downloaded_pdf.pdf";
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    console.log('url instanceof Blob', url instanceof Blob)
    if (url instanceof Blob) {
      const a = document.createElement("a");
      a.href = url;
      a.style.display = "none";
      a.target = "_blank";
      a.download = url || "downloaded_pdf.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobURL = URL.createObjectURL(blob);
          console.log('blobURL', blobURL)
          const a = document.createElement("a");
          a.href = blobURL;
          a.style.display = "none";
          a.download = url || "downloaded_pdf.pdf"; // Set the desired filename
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        })
        .catch((error) => console.log("Download error:", error));
    }
  }

  function formatBytes(bytes) {
    const units = ["B", "KB", "MB", "GB"];
    let index = 0;
    while (bytes >= 1024 && index < units.length - 1) {
      bytes /= 1024;
      index++;
    }
    return bytes.toFixed(2) + " " + units[index];
  }
  console.log('docLink', docLink)
  if (error) {
    return (
      <div>
        <div className="msg-doc_main">
          <img src="/images/docicon.png" width={25} />
          <div className="msg-doc_content">
            <div className="msg-doc_name">
              {(message && message.content && message.content.fileName) ||
                docLink.split("/").pop()}
            </div>
            <div className="msg-doc_size">
              <span>
                {message &&
                  message.content &&
                  message.content.fileSize &&
                  formatBytes(message.content.fileSize)}
              </span>{" "}
              <span>{docType && docType.split("/").at(-1)}</span>
            </div>
          </div>
          <Retry onClick={() => sendMessage()} type={"document"} />
        </div>
      </div>
    );
  }

  const caption = (message && message.content && message.content.caption) || "";
  console.log("messageDocument", message);

  const MessageImage = message.from == "customer" ? CustomerDoc : AgentDoc;
  return (
    <MessageImage>
      <div className="msg-doc_main">
        <img src="/images/docicon.png" width={25} />
        <div className="msg-doc_content">
          <div className="msg-doc_name">
            {(message && message.content && message.content.fileName) ||
              docLink.split("/").pop()}
          </div>
          <div className="msg-doc_size">
            {/* <span>
            {(message &&
              message.content &&
              message.content.fileSize &&
              formatBytes(message.content.fileSize)) ||
              "null"}
          </span> */}
            <span className="">{docType && docType.split("/").at(-1)}</span>
          </div>
        </div>
        {loading ? (
          <Loader loadingPercentage={loading} type={"document"} />
        ) : (
          <div
            className="msg-doc_download_button"
            onClick={() => downloadPDF(message && message.content && message.content.link ? message.content.link : docLink)}
            style={{ cursor: "pointer" }}
          >
            <img src="/images/Group.svg" />
            {/* <span class="material-symbols-outlined msg-doc_color msg-doc_pointer">download</span> */}
          </div>
        )}

      </div>
      <p className="caption" dangerouslySetInnerHTML={{ __html: formatMessage(caption && caption) }} />
    </MessageImage>
  );
}

// export default ImageOrientationChecker;
const stateToProps = (state) => ({
  selectedAssignedList: chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  ),
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  assignedList: chatSelector.getChatDynamic(state, "assignedList"),
  selectedDocs: chatSelector.getChatDynamic(state, "selectedDocs"),
  retryDocs: chatSelector.getChatDynamic(state, "retryDocument"),
});

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
});
export default connect(stateToProps, dispatchToProps)(DocumentCustom);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/DocumentCustom.js